import {useTranslation} from "react-i18next";
import ConfirmDialog from "../../dialog/ConfirmDialog";
import {type LegalEntity} from "../AdminTypes";

type BillingDeleteOverrideDialogProps = {
    deleteErrorMessage: string;
    selectedEntity: LegalEntity | null;
    isDeletePending: boolean;
    isDeleteDialogOpen: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
};

const BillingDeleteOverrideDialog = ({
    deleteErrorMessage,
    isDeletePending,
    isDeleteDialogOpen,
    selectedEntity,
    onClose,
    onConfirm,
}: BillingDeleteOverrideDialogProps) => {
    const {t: translate} = useTranslation();

    return (
        <ConfirmDialog
            open={isDeleteDialogOpen}
            title={translate("admin.billing.legalEntityPrice.deleteDialog.title")}
            message={translate("admin.billing.legalEntityPrice.deleteDialog.message", {
                legalEntityName:
                    selectedEntity?.name ??
                    translate("admin.billing.legalEntityPrice.deleteDialog.fallbackLegalEntity"),
            })}
            confirmLabel={translate("admin.billing.legalEntityPrice.deleteDialog.confirm")}
            cancelLabel={translate("common.cancel")}
            errorMessage={deleteErrorMessage}
            onConfirm={() => void onConfirm()}
            onClose={onClose}
            isLoading={isDeletePending}
        />
    );
};

export default BillingDeleteOverrideDialog;
